import React, { Dispatch, SetStateAction, useCallback, useMemo, useState } from 'react';
import { TagGq } from '../../../../../../graphql/projects/models/TagGq';
import { TagGroupGq } from '../../../../../../graphql/projects/models/TagGroupGq';
import { projectsApiService } from '../../../../../../graphql/projects/projectsApiService';
import VoxelRadio from '../../../../../../components/voxel/Forms/VoxelRadio';
import { ConflictTableState } from './logic/useConflictTableState';

export interface ConflictingTagsMultiSelectProps {
  tagGroup: TagGroupGq;
  tableState: ConflictTableState;
  areConflictsSelected: boolean;
  bulkSelectedTag: number;
  setBulkSelectedTag: Dispatch<SetStateAction<number>>;
}


const ConflictingTagsMultiSelect: React.FC<ConflictingTagsMultiSelectProps> = ({
  tagGroup,
  tableState,
  areConflictsSelected,
  bulkSelectedTag,
  setBulkSelectedTag
}) => {

  const conflictingTagsQuery = projectsApiService.queries.useGetConflictingTags({
    tagGroupId: tagGroup.id,
    keywordQuery: {
      filtering: tableState.backendFilterState,
      selecting: tableState.backendSelectionState,
    },
  });

  const conflictingTags = useMemo(() => {
    return conflictingTagsQuery?.conflictingTags;
  }, [conflictingTagsQuery?.conflictingTags, conflictingTagsQuery?.query?.loading]);

  const toggleTagSelection = (tagId: number) => {
    if (bulkSelectedTag === tagId) {
      setBulkSelectedTag(null)
    } else {
      setBulkSelectedTag(tagId)
    }
  };

  return (
    <div className='flex flex-row flex-wrap justify-start gap-x-6 gap-y-3'>
      {conflictingTags?.map((tag) => (
        <VoxelRadio
          title={tag.name}
          value={tag.id}
          disabled={!areConflictsSelected}
          selectedOption={bulkSelectedTag}
          setSelectedOption={() => toggleTagSelection(tag.id)}
        />
      ))}
    </div>
  );
};

export default ConflictingTagsMultiSelect;
